import type { Assembler } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import type { AssemblerInfoInput } from '@@partner:graphql/mutation/employees/saveAssembler.gql'
import { mergeLeft } from 'merge-left-utils'

export interface AssemblerFormState {
  id?: GQL_ID
  firstName: string
  lastName: string
  phone: string
  status: number
  shopId?: GQL_ID
  role: 'picker' | 'packer' | 'assembler' | 'leader'
}

export const ASSEMBLER_DEFAULT_STATE: AssemblerFormState = {
  id: undefined,
  firstName: '',
  lastName: '',
  phone: '',
  status: 0,
  shopId: undefined,
  role: 'assembler'
}

export const makeAssemblerFormState = (): AssemblerFormState => {
  return ASSEMBLER_DEFAULT_STATE //mapApiDataToState(assembler)
}

// state and api variable are same excluding info fields
// so drop them and go
export const mapStateToApiVariable = (
  state: AssemblerFormState
): AssemblerInfoInput => ({
  id: state.id,
  first_name: state.firstName,
  last_name: state.lastName,
  phone: state.phone,
  status: Number(state.status) ?? 0,
  shop_id: state.shopId,
  role: state.role
})

export const mapApiDataToState = (data: Assembler): AssemblerFormState => ({
  id: data.id,
  firstName: data.first_name,
  lastName: data.last_name,
  phone: data.phone,
  status: Number(data.status),
  shopId: Number(data?.shop?.id),
  role: data.role
})
